import React from 'react'
import { FaUserAlt, FaCalendarAlt } from 'react-icons/fa'

export default function CourseCards({cost,title,instructor,days,studentsno,image}) {
  return (
    <div className='h-100  w-[350px] mb-5 shadow-md rounded-lg overflow-hidden hover:shadow-2xl   transition-transform duration-600 ease-in-out'>
      <div className='overflow-hidden shadow-md p-2  bg-white rounded-md'>
        <img 
          src={image} 
          alt={title} 
          className='w-full h-[180px] rounded-xl ' />
      </div>
      <div className='p-4'>
        <div className='mb-2 '>
          <p className='text-xl font-semibold flex text-cuscolor-light justify-center'>{title}</p>
          <p className='text-gray-600 mt-2 mb-2 font-serif text-xl flex justify-center'>Rs {cost}</p>
        </div>
        <div className='flex items-center text-gray-500'>
          <hr className='w-full border-t border-gray-300' />
        </div>
        <div className='mt-2 flex items-center text-sm text-gray-600'>
          <p className='flex items-center text-cuscolor'>
            <FaUserAlt className='mr-2  text-cuscolor-light ' />
            {instructor}
          </p>
          <div className='mx-2 h-4 w-px bg-gray-300'></div>
          <p className='flex items-center text-cuscolor'>
            <FaCalendarAlt className='mr-2  text-cuscolor-light' />
            {days} days
          </p>
          <div className='mx-2 h-4 w-px bg-gray-300'></div>
          <p className='flex items-center text-cuscolor'>
          <FaUserAlt className='mr-2 text-cuscolor-light' />

            {studentsno} students
          </p>
        </div>
      </div>
    </div>
  )
}
